<template>
  <el-dialog
    title="资讯详情"
    :visible="true"
    width="1400px"
    :before-close="() => handleClose(false)"
    class="public-preview-dialog"
    top="0"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <div class="page-publicDetail" ref="viewRef">
      <div class="publicDetail-content">
        <div class="d-title" v-html="publicDetail.title" />
        <div class="d-source-time">
          <div>
            <span>时间：{{ publicDetail.publishTime }}</span>
            <span>来源：{{ publicDetail.infoSource }}</span>
          </div>
        </div>
        <div class="d-introduce" v-if="publicDetail.infoIntroduce">
          <h3>导语：</h3>
          <p>{{ publicDetail.infoIntroduce }}</p>
        </div>
        <div class="d-content" v-html="publicDetail.content"></div>
        <div class="d-file" v-if="publicDetail.attachFileList && publicDetail.attachFileList.length > 0">
          <div class="d-file-title">附件</div>
          <div
            class="d-file-files"
            v-for="(item, index) in publicDetail.attachFileList"
            :key="item.name + index"
          >
            <a :href="item.downUrl" target="_blank">
              {{ `${index + 1}.${item.name}` }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'InformationPreview',
  props: ['handleClose', 'viewData'],
  data() {
    return {
      publicDetail: this.viewData
    }
  }
}
</script>
<style lang="scss" scoped>
.page-publicDetail {
  padding: 28px 0 88px 0;
  background: #eef3ff;

  .publicDetail-content {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    padding-bottom: 107px;
    .d-title {
      // margin: 20px auto 49px;
      // font-size: 36px;
      font-family: Microsoft YaHei;
      // font-weight: bold;
      // color: #0853b6;
      text-align: center;
    }
    .d-source-time {
      width: 1127px;
      height: 56px;
      background: rgba($color: #000000, $alpha: 0.1);
      margin: 0 auto 41px;
      line-height: 56px;
      display: flex;
      justify-content: space-between;
      > div:first-child {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        > span:first-child {
          margin: 0 20px 0 61px;
        }
      }
    }
    .d-introduce {
      width: 1126px;
      height: 142px;
      background: #f2f2f2;
      margin: 0 auto 40px;
      box-sizing: border-box;
      padding: 30px 50px;
      > h3 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        margin-bottom: 20px;
      }
      > p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
      }
    }
    .d-img {
      text-align: center;
      margin: 0 auto 58px;
      img {
        max-width: 100%;
      }
    }
    .d-content {
      width: 1024px;
      margin: 0 auto 49px;
      * {
        max-width: 100%;
      }
    }
    .d-file {
      margin: 0 0 118px 88px;
      .d-file-title {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        text-decoration: underline;
        color: #333333;
        margin-bottom: 10px;
      }
      .d-file-files {
        margin-bottom: 10px;
        > a {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          text-decoration: underline;
          color: #0e2cf8;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
